import {API} from "aws-amplify";

export const getOrganizations = async (query) => {
  return await API.get('MyAPI', `/contacts`, {
    queryStringParameters: { 
      ...query
    },
  });
};
